import AidStudioTab from 'containers/admin/clients/client/tabs-components/aid-studio-tab';

import { useCurrentUser } from 'hooks/api/use-current-user';

import { Loader } from 'ui/loader';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

const AidStudio = () => {
  const currentUser = useCurrentUser();
  const clientId = currentUser?.data?.client?.id;

  if (currentUser?.loading) {
    return <Loader loading />;
  }

  if (!clientId) {
    return null;
  }

  return (
    <ResponsiveWrapper>
      <AidStudioTab clientId={clientId} isUserView />
    </ResponsiveWrapper>
  );
};

export default AidStudio;
